import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Formik } from 'formik';
import { useObjectContext } from '@/hooks/useObjectContext';
import { AddUnlayerEmailForm } from '@/components/Drawers/AddUnlayerEmailDrawer/AddUnlayerEmailForm';
import { validationSchema } from '@/components/Drawers/AddUnlayerEmailDrawer/constants';
import { useUnlayerComposePresets } from '@/components/Drawers/AddUnlayerEmailDrawer/hooks/useUnlayerComposePresets';
import { UnlayerUIProvider } from '@/context/UnlayerUIContext';
import { UnlayerTemplateProvider } from '@/context/UnlayerTemplateContext';
import { UnlayerDraftProvider } from '@/context/UnlayerDraftContext';
import { UnlayerSendProvider, useUnlayerSendContext } from '@/context/UnlayerSendContext';
import { UnlayerMergeTagsProvider } from '@/context/UnlayerMergeTagsContext';
import { UnlayerSignatureProvider } from '@/context/UnlayerSignatureContext';
import { UnlayerComposeInteractionsProvider } from '@/context/UnlayerComposeInteractionsContext';

const AddUnlayerEmailDrawerForm = ({ initialValues }) => {
	const { handleSubmit } = useUnlayerSendContext();

	return (
		<Formik
			initialValues={initialValues}
			validationSchema={validationSchema}
			validateOnChange={false}
			validateOnBlur={true}
			enableReinitialize={true}
			onSubmit={handleSubmit}
		>
			<UnlayerUIProvider>
				<UnlayerTemplateProvider>
					<UnlayerDraftProvider>
						<UnlayerMergeTagsProvider>
							<UnlayerSignatureProvider>
								<UnlayerComposeInteractionsProvider>
									<AddUnlayerEmailForm />
								</UnlayerComposeInteractionsProvider>
							</UnlayerSignatureProvider>
						</UnlayerMergeTagsProvider>
					</UnlayerDraftProvider>
				</UnlayerTemplateProvider>
			</UnlayerUIProvider>
		</Formik>
	);
};

/**
 * Container for the Unlayer email composer drawer.
 * Resolves preset context, user data, and submit wiring before handing off to the form UI.
 */
export const AddUnlayerEmailDrawer = () => {
	const params = useParams();
	const { clientRow, dealRow } = useObjectContext();

	const open = useSelector((state) => state.dialog?.open?.unlayerEmail) ?? false;
	const dialogData = useSelector((state) => state.dialog?.data?.unlayerEmail) ?? {};
	const { initialValues } = useUnlayerComposePresets({
		params,
		clientRow,
		dealRow,
		dialogData,
	});

	if (!open) return <></>;

	return (
		<UnlayerSendProvider>
			<AddUnlayerEmailDrawerForm initialValues={initialValues} />
		</UnlayerSendProvider>
	);
};
